import React, { createContext, useContext, useState, ReactNode } from 'react';
import enUS from '../locales/en-US.json';
import frCA from '../locales/fr-CA.json';

type Language = 'en-US' | 'fr-CA';

type Translations = typeof enUS;

const translations: Record<Language, Translations> = {
  'en-US': enUS,
  'fr-CA': frCA,
};

interface LanguageContextProps {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: keyof Translations) => string;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>('en-US');
  const t = (key: keyof Translations) => translations[language][key] || key;
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}; 